// Category types
export interface Category {
  id: number;
  name: string;
  description: string | null;
  position: number | null;
  hidden: boolean;
  availabilities?: CategoryAvailability[];
}

export interface CategoryAvailability {
  id: number;
  category_id: number;
  day_of_week: string;
  start_time: string;
  end_time: string;
}

// Product types
export interface Product {
  id: number;
  code: string;
  name: string;
  description: string;
  price: number;
  image_url?: string;
  is_featured: boolean;
  unavailable: boolean;
  category_id?: number;
  categories?: Category[];
  product_types?: ProductType[];
  addons?: Addon[];
}

export interface ProductFull extends Product {
  addons: Addon[];
}

export interface ProductType {
  id: number;
  product_id: number;
  name: string;
  price: number;
  addons?: Addon[]; // Agregar esta propiedad si es necesario
}

// Addon types
export interface Addon {
  id: number;
  name: string;
  kind: number; // 1: required, 2: optional, etc.
  selections: Selection[];
}

export interface Selection {
  id: number;
  name: string;
  prices: SelectionPrice[];
}

export interface SelectionPrice {
  id: number;
  selection_id: number;
  price: number;
  kind: number; // Indicator of size or product type
}

// Menu section response
export interface MenuSection {
  category: Category;
  products: Product[];
}

// Enums
export enum AddonKind {
  Required = 1,
  Optional = 2,
  Multiple = 3,
}

// Helper functions
export const getAddonKindName = (kind: number): string => {
  switch (kind) {
    case AddonKind.Required:
      return "Required";
    case AddonKind.Optional:
      return "Optional";
    case AddonKind.Multiple:
      return "Multiple Selection";
    default:
      return "Unknown";
  }
};

// Format price from cents to dollars with currency symbol
export const formatPrice = (cents: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(cents / 100);
};
